module.exports = __webpack_public_path__ + "img/cover1.3f590170.jpg";